import React, { FC, memo } from 'react'
import { IconButtonComponentProps, IconButtonStyled } from './IconButton.styled'

export const IconButton: FC<IconButtonComponentProps> = memo((props) => {
    return <IconButtonStyled data-automation-id={props.id} {...props} />
})
